/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

import { ProgressStatusEnum } from "../enum/partner/progress.status.enum";

/**
 * @description
 * Icons displayed on PartnerReportList depending on status of report
 */
export const reportStatusIconMap = new Map<ProgressStatusEnum, string>([
  [ProgressStatusEnum.DRAFT, "mdi-moon-new"],
  [ProgressStatusEnum.NEW, "mdi-circle"],
  [ProgressStatusEnum.IN_PROGRESS, "mdi-arrow-right-drop-circle-outline"],
  [ProgressStatusEnum.FINISHED, "mdi-record-circle-outline"],
  [ProgressStatusEnum.DELETED, "mdi-trash-can-outline"]
]);

export const reportStateMap = new Map<ProgressStatusEnum, { color: string; label: string }>([
  [ProgressStatusEnum.DRAFT, { color: "grey", label: "Draft" }],
  [ProgressStatusEnum.NEW, { color: "secondary", label: "Open" }],
  [ProgressStatusEnum.IN_PROGRESS, { color: "primary", label: "In Progress" }],
  [ProgressStatusEnum.FINISHED, { color: "deep-purple lighten-1", label: "Done" }],
  [ProgressStatusEnum.DELETED, { color: "grey darken-3", label: "Archived" }]
]);
